export default "__VITE_ASSET__D3YYHzGV__"